import Http from '../containers/App/Http';
import store from '../containers/App/store'
import {setAllSubmissions} from "../redux/actions/submissionsActions";

export default class Submissions{

    getSubmissions(limit,queryPageIndex, queryPageSize){
        // FETCH THE Users
        const formData = new FormData();
        formData.append('queryPageIndex',queryPageIndex);
        formData.append('queryPageSize',queryPageSize);
        formData.append('limit',limit??100);

        return Http.post("/s/getSubmissions",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            await store.dispatch(setAllSubmissions(response.data.data));
            return response;
        });
    };

    getNotes(limit,queryPageIndex, queryPageSize){
        // FETCH THE Users
        const formData = new FormData();
        formData.append('queryPageIndex',queryPageIndex);
        formData.append('queryPageSize',queryPageSize);
        formData.append('limit',limit??100);

        return Http.post("/s/getNotes",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            return response;
        });
    };

}